import { z } from "zod";
export const discoverySchemas = {
  list_services: z.strictObject({ limit: z.number().int().min(1).max(20).optional() }),
  get_service: z.strictObject({ slug: z.string().min(1).max(120).regex(/^[a-z0-9-]+$/) }),
  list_pricing: z.strictObject({}),
  list_case_studies: z.strictObject({ limit: z.number().int().min(1).max(20).optional() }),
  get_case_study: z.strictObject({ slug: z.string().min(1).max(120).regex(/^[a-z0-9-]+$/) }),
  search_content: z.strictObject({ query: z.string().trim().min(2).max(160), limit: z.number().int().min(1).max(10).optional() }),
};
export type DiscoveryAction = keyof typeof discoverySchemas;
